import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

import Button from "core/Button";

import { SUBMIT_PHOTO_UPLOADS_FOR_REVIEW } from "./mutations";

import { PHOTO_UPLOAD } from "data/links";

const PhotoUploadSubmit = ({
    uploadCount,
    currentlyProcessingCount,
    initialMaximumFiles,
    setShowSubmissionError
}) => {
    const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

    const [submitUploads, { loading }] = useMutation(
        SUBMIT_PHOTO_UPLOADS_FOR_REVIEW,
        {
            onCompleted: ({ submitPhotoUploadsForReview }) => {
                if (submitPhotoUploadsForReview.ok) {
                    setSubmissionSuccessful(true);
                } else {
                    setShowSubmissionError(true);
                }
            }
        }
    );

    const handleButtonClick = () => {
        submitUploads();
    };

    const buttonIsDisabled =
        uploadCount < 1 ||
        currentlyProcessingCount > 0 ||
        uploadCount > initialMaximumFiles;

    if (submissionSuccessful) {
        return (
            <Redirect
                to={{
                    pathname: PHOTO_UPLOAD,
                    state: {
                        enterConfirmationMode: true
                    }
                }}
            />
        );
    }

    return (
        <Button
            onClick={handleButtonClick}
            isDisabled={buttonIsDisabled}
            isProcessing={loading}
        >
            Submit
        </Button>
    );
};

PhotoUploadSubmit.propTypes = {
    uploadCount: PropTypes.number,
    currentlyProcessingCount: PropTypes.number,
    initialMaximumFiles: PropTypes.number.isRequired,
    setShowSubmissionError: PropTypes.func.isRequired
};

export default PhotoUploadSubmit;
